// Rate requests
export const RATE_LIST = "RATE_LIST";
export const RATE_CREATE = "RATE_CREATE";
export const RATE_UPDATE = "RATE_UPDATE";
export const RATE_FILTER = "RATE_FILTER";

// Rate success
export const RATE_LIST_SUCCESS = "RATE_LIST_SUCCESS";
export const RATE_CREATE_SUCCESS = "RATE_CREATE_SUCCESS";
export const RATE_UPDATE_SUCCESS = "RATE_UPDATE_SUCCESS";

// Rate failed
export const RATE_REQUEST_FAILED = "RATE_REQUEST_FAILED";
